// "use client";

// import type React from "react";

// import {
//   ArrowRight,
//   CheckCircle,
//   Github,
//   Linkedin,
//   Mail,
//   MapPin,
//   Phone,
//   Send,
//   Twitter,
// } from "lucide-react";
// import { useEffect, useRef, useState } from "react";
// import { Images } from "../assets/images";

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [submitSuccess, setSubmitSuccess] = useState(false);
//   const [submitError, setSubmitError] = useState("");
//   const [activeTab, setActiveTab] = useState<"message" | "social">("message");
//   const [focusedInput, setFocusedInput] = useState<string | null>(null);
//   const formRef = useRef<HTMLDivElement>(null);
//   const [isVisible, setIsVisible] = useState(false);

//   // Observer pour les animations d'entrée
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.disconnect();
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (formRef.current) {
//       observer.observe(formRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   const handleChange = (
//     e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//   ) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     // Simuler un envoi de formulaire
//     setTimeout(() => {
//       setIsSubmitting(false);
//       setSubmitSuccess(true);
//       setFormData({ name: "", email: "", subject: "", message: "" });

//       // Réinitialiser le message de succès après 5 secondes
//       setTimeout(() => {
//         setSubmitSuccess(false);
//       }, 5000);
//     }, 1500);
//   };

//   const socialLinks = [
//     {
//       name: "GitHub",
//       icon: <Github size={24} />,
//       url: "https://github.com/ivanDev237",
//       color:
//         "bg-gradient-to-r from-gray-700 to-gray-900 hover:from-gray-800 hover:to-black",
//     },
//     {
//       name: "LinkedIn",
//       icon: <Linkedin size={24} />,
//       url: "https://www.linkedin.com/in/yankoua-ivan-4442902a9",
//       color:
//         "bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900",
//     },
//     {
//       name: "Twitter",
//       icon: <Twitter size={24} />,
//       url: "https://x.com/IvanTsomo67894",
//       color:
//         "bg-gradient-to-r from-sky-400 to-sky-600 hover:from-sky-500 hover:to-sky-700",
//     },
//     {
//       name: "Email",
//       icon: <Mail size={24} />,
//       url: "mailto:tsomoivan@gmail.com",
//       color:
//         "bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700",
//     },
//     {
//       name: "Téléphone",
//       icon: <Phone size={24} />,
//       url: "tel:+237650695112",
//       color:
//         "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700",
//     },
//   ];

//   return (
//     <section id="contact" className="py-20 relative overflow-hidden">
//       {/* Éléments décoratifs d'arrière-plan */}
//       <div className="absolute inset-0 -z-10 overflow-hidden">
//         <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-background to-background/50"></div>
//         <div className="absolute top-40 -left-20 w-80 h-80 bg-primary/10 rounded-full filter blur-3xl"></div>
//         <div className="absolute bottom-40 -right-20 w-80 h-80 bg-accent/10 rounded-full filter blur-3xl"></div>
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200%] h-40 bg-muted/20 -rotate-12"></div>
//       </div>

//       <div className="container mx-auto px-4 relative z-10">
//         <div className="max-w-4xl mx-auto text-center mb-16">
//           <h2 className="text-3xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
//             Discutons de votre projet
//           </h2>
//           <div className="h-1 w-20 bg-gradient-to-r from-primary to-accent mx-auto mb-8"></div>
//           <p className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto">
//             Vous avez un projet en tête ou une opportunité à me proposer ? Je
//             suis toujours ouvert à discuter de nouvelles idées et
//             collaborations.
//           </p>
//         </div>

//         <div
//           ref={formRef}
//           className={`max-w-5xl mx-auto bg-card rounded-2xl shadow-xl overflow-hidden transition-all duration-1000 ${
//             isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
//           }`}
//         >
//           <div className="grid grid-cols-1 lg:grid-cols-5">
//             {/* Panneau latéral avec informations de contact */}
//             <div className="lg:col-span-2 bg-gradient-to-br from-primary/90 to-accent/90 p-8 lg:p-12 text-white relative">
//               {/* Éléments décoratifs */}
//               <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-x-10 -translate-y-20"></div>
//               <div className="absolute bottom-0 left-0 w-40 h-40 bg-white/10 rounded-full translate-x-10 translate-y-20"></div>

//               <div className="relative z-10">
//                 <h3 className="text-2xl font-bold mb-6 text-center">
//                   Restons en contact
//                 </h3>

//                 <div className="mb-12">
//                   <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border-2 border-white/20 mx-auto">
//                     <img
//                       src={Images.hero1}
//                       alt="profile picture"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                   <h4 className="text-xl font-semibold text-center mb-1">
//                     Yankoua Ivan
//                   </h4>
//                   <p className="text-white/80 text-center mb-6">
//                     Développeur Fullstack Node.js
//                   </p>
//                 </div>

//                 <div className="space-y-6">
//                   <div className="flex items-start">
//                     <div className="mr-4 bg-white/10 p-3 rounded-full">
//                       <Mail className="text-white" size={20} />
//                     </div>
//                     <div>
//                       <h4 className="text-sm font-semibold mb-1 text-white/80">
//                         Email
//                       </h4>
//                       <a
//                         href="mailto:john.doe@example.com"
//                         className="text-white hover:underline transition-all"
//                       >
//                         tsomoivan@gmail.com
//                       </a>
//                     </div>
//                   </div>

//                   <div className="flex items-start">
//                     <div className="mr-4 bg-white/10 p-3 rounded-full">
//                       <Phone className="text-white" size={20} />
//                     </div>
//                     <div>
//                       <h4 className="text-sm font-semibold mb-1 text-white/80">
//                         Téléphone
//                       </h4>
//                       <a
//                         href="tel:+237650695112"
//                         className="text-white hover:underline transition-all"
//                       >
//                         +237 650 69 51 12
//                       </a>
//                     </div>
//                   </div>

//                   <div className="flex items-start">
//                     <div className="mr-4 bg-white/10 p-3 rounded-full">
//                       <MapPin className="text-white" size={20} />
//                     </div>
//                     <div>
//                       <h4 className="text-sm font-semibold mb-1 text-white/80">
//                         Localisation
//                       </h4>
//                       <p className="text-white">Cameroun, Douala</p>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mt-12 pt-8 border-t border-white/20">
//                   <p className="text-white/80 mb-4 text-sm">
//                     Prêt à transformer vos idées en réalité ? Contactez-moi dès
//                     aujourd'hui pour discuter de votre projet.
//                   </p>
//                   <div className="flex space-x-3">
//                     <a
//                       href="https://github.com/ivanDev237"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors"
//                       aria-label="GitHub"
//                     >
//                       <Github size={18} />
//                     </a>
//                     <a
//                       href="https://www.linkedin.com/in/yankoua-ivan-4442902a9"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors"
//                       aria-label="LinkedIn"
//                     >
//                       <Linkedin size={18} />
//                     </a>
//                     <a
//                       href="https://x.com/IvanTsomo67894"
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors"
//                       aria-label="Twitter"
//                     >
//                       <Twitter size={18} />
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Formulaire et onglets */}
//             <div className="lg:col-span-3 p-8 lg:p-12">
//               <div className="flex mb-8 border-b border-muted">
//                 <button
//                   onClick={() => setActiveTab("message")}
//                   className={`pb-3 px-4 font-medium text-lg transition-colors relative ${
//                     activeTab === "message"
//                       ? "text-primary"
//                       : "text-foreground/60 hover:text-foreground/80"
//                   }`}
//                 >
//                   Envoyer un message
//                   {activeTab === "message" && (
//                     <div className="absolute bottom-0 left-0 w-full h-0.5 bg-primary"></div>
//                   )}
//                 </button>
//                 <button
//                   onClick={() => setActiveTab("social")}
//                   className={`pb-3 px-4 font-medium text-lg transition-colors relative ${
//                     activeTab === "social"
//                       ? "text-primary"
//                       : "text-foreground/60 hover:text-foreground/80"
//                   }`}
//                 >
//                   Réseaux sociaux
//                   {activeTab === "social" && (
//                     <div className="absolute bottom-0 left-0 w-full h-0.5 bg-primary"></div>
//                   )}
//                 </button>
//               </div>

//               {activeTab === "message" ? (
//                 <form onSubmit={handleSubmit} className="space-y-6">
//                   <div
//                     className={`relative transition-all duration-300 ${
//                       focusedInput === "name" ? "transform -translate-y-2" : ""
//                     }`}
//                   >
//                     <label
//                       htmlFor="name"
//                       className={`absolute left-4 transition-all duration-300 ${
//                         focusedInput === "name" || formData.name
//                           ? "text-xs text-primary -top-2 bg-card px-2"
//                           : "text-foreground/60 top-3"
//                       }`}
//                     >
//                       Nom complet
//                     </label>
//                     <input
//                       type="text"
//                       id="name"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       onFocus={() => setFocusedInput("name")}
//                       onBlur={() => setFocusedInput(null)}
//                       required
//                       className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                     />
//                   </div>

//                   <div
//                     className={`relative transition-all duration-300 ${
//                       focusedInput === "email" ? "transform -translate-y-2" : ""
//                     }`}
//                   >
//                     <label
//                       htmlFor="email"
//                       className={`absolute left-4 transition-all duration-300 ${
//                         focusedInput === "email" || formData.email
//                           ? "text-xs text-primary -top-2 bg-card px-2"
//                           : "text-foreground/60 top-3"
//                       }`}
//                     >
//                       Email
//                     </label>
//                     <input
//                       type="email"
//                       id="email"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       onFocus={() => setFocusedInput("email")}
//                       onBlur={() => setFocusedInput(null)}
//                       required
//                       className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                     />
//                   </div>

//                   <div
//                     className={`relative transition-all duration-300 ${
//                       focusedInput === "subject"
//                         ? "transform -translate-y-2"
//                         : ""
//                     }`}
//                   >
//                     <label
//                       htmlFor="subject"
//                       className={`absolute left-4 transition-all duration-300 ${
//                         focusedInput === "subject" || formData.subject
//                           ? "text-xs text-primary -top-2 bg-card px-2"
//                           : "text-foreground/60 top-3"
//                       }`}
//                     >
//                       Sujet
//                     </label>
//                     <input
//                       type="text"
//                       id="subject"
//                       name="subject"
//                       value={formData.subject}
//                       onChange={handleChange}
//                       onFocus={() => setFocusedInput("subject")}
//                       onBlur={() => setFocusedInput(null)}
//                       required
//                       className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
//                     />
//                   </div>

//                   <div
//                     className={`relative transition-all duration-300 ${
//                       focusedInput === "message"
//                         ? "transform -translate-y-2"
//                         : ""
//                     }`}
//                   >
//                     <label
//                       htmlFor="message"
//                       className={`absolute left-4 transition-all duration-300 ${
//                         focusedInput === "message" || formData.message
//                           ? "text-xs text-primary -top-2 bg-card px-2"
//                           : "text-foreground/60 top-3"
//                       }`}
//                     >
//                       Message
//                     </label>
//                     <textarea
//                       id="message"
//                       name="message"
//                       value={formData.message}
//                       onChange={handleChange}
//                       onFocus={() => setFocusedInput("message")}
//                       onBlur={() => setFocusedInput(null)}
//                       required
//                       rows={5}
//                       className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
//                     ></textarea>
//                   </div>

//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="w-full px-6 py-4 bg-gradient-to-r from-primary to-accent text-white rounded-lg hover:shadow-lg transition-all flex items-center justify-center disabled:opacity-70 group"
//                   >
//                     {isSubmitting ? (
//                       <span className="flex items-center">
//                         <svg
//                           className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                         Envoi en cours...
//                       </span>
//                     ) : (
//                       <span className="flex items-center">
//                         <Send size={18} className="mr-2" />
//                         Envoyer le message
//                         <ArrowRight
//                           size={18}
//                           className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1"
//                         />
//                       </span>
//                     )}
//                   </button>

//                   {submitSuccess && (
//                     <div className="p-4 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 rounded-lg flex items-start">
//                       <CheckCircle
//                         className="text-green-600 dark:text-green-400 mr-3 mt-0.5"
//                         size={18}
//                       />
//                       <div>
//                         <p className="font-medium">
//                           Message envoyé avec succès !
//                         </p>
//                         <p className="text-sm mt-1">
//                           Merci pour votre message. Je vous répondrai dès que
//                           possible.
//                         </p>
//                       </div>
//                     </div>
//                   )}

//                   {submitError && (
//                     <div className="p-4 bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 rounded-lg">
//                       {submitError}
//                     </div>
//                   )}
//                 </form>
//               ) : (
//                 <div className="space-y-4 py-4">
//                   <p className="text-foreground/80 mb-6">
//                     Retrouvez-moi sur les réseaux sociaux ou contactez-moi
//                     directement via ces plateformes :
//                   </p>

//                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                     {socialLinks.map((link, index) => (
//                       <a
//                         key={link.name}
//                         href={link.url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className={`${link.color} text-white p-4 rounded-lg flex items-center transition-all hover:shadow-lg transform hover:-translate-y-1`}
//                         style={{ animationDelay: `${index * 100}ms` }}
//                       >
//                         <div className="bg-white/20 p-3 rounded-full mr-4">
//                           {link.icon}
//                         </div>
//                         <div>
//                           <p className="font-medium">{link.name}</p>
//                           <p className="text-sm text-white/80">
//                             {link.name === "Email"
//                               ? "tsomoivan@gmail.com"
//                               : link.name === "Téléphone"
//                               ? "+237 650 69 51 12"
//                               : `@ivanDev237`}
//                           </p>
//                         </div>
//                         <ArrowRight className="ml-auto" size={18} />
//                       </a>
//                     ))}
//                   </div>

//                   <div className="mt-8 pt-6 border-t border-muted">
//                     <h4 className="text-lg font-medium mb-4">Disponibilité</h4>
//                     <div className="bg-muted/30 p-4 rounded-lg">
//                       <p className="text-foreground/80">
//                         Je suis actuellement{" "}
//                         <span className="text-green-500 font-medium">
//                           disponible
//                         </span>{" "}
//                         pour des projets freelance et des opportunités d'emploi
//                         à temps plein.
//                       </p>
//                       <div className="mt-4 flex items-center">
//                         <div className="w-3 h-3 bg-green-500 rounded-full mr-2 animate-pulse"></div>
//                         <p className="text-sm text-foreground/60">
//                           Réponse généralement en moins de 24 heures
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;

"use client";

import type React from "react";

import {
  ArrowRight,
  CheckCircle,
  Github,
  Linkedin,
  Mail,
  MapPin,
  Phone,
  Send,
  Twitter,
} from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Images } from "../assets/images";

// Importez EmailJS au début du fichier
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [activeTab, setActiveTab] = useState<"message" | "social">("message");
  const [focusedInput, setFocusedInput] = useState<string | null>(null);
  const formRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  // Observer pour les animations d'entrée
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (formRef.current) {
      observer.observe(formRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Remplacez la fonction handleSubmit par celle-ci:
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError("");

    try {
      // Préparation des paramètres pour EmailJS
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        subject: formData.subject,
        message: formData.message,
      };

      // Envoi de l'email via EmailJS
      // Remplacez "YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID" et "YOUR_PUBLIC_KEY" par vos identifiants EmailJS
      await emailjs.send(
        "service_ozgu0xd", //YOUR_SERVICE_ID
        "template_7kni4p9", // YOUR_TEMPLATE_ID
        templateParams,
        "jQJlBsCPl4P3gr00Q" //YOUR_PUBLIC_KEY
      );

      // Gestion du succès
      setSubmitSuccess(true);
      setFormData({ name: "", email: "", subject: "", message: "" });

      // Réinitialiser le message de succès après 5 secondes
      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);
    } catch (error) {
      console.error("Erreur lors de l'envoi de l'email:", error);
      setSubmitError(
        "Une erreur s'est produite lors de l'envoi du message. Veuillez réessayer."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const socialLinks = [
    {
      name: "GitHub",
      icon: <Github size={24} />,
      url: "https://github.com/ivanDev237",
      color:
        "bg-gradient-to-r from-gray-700 to-gray-900 hover:from-gray-800 hover:to-black",
    },
    {
      name: "LinkedIn",
      icon: <Linkedin size={24} />,
      url: "https://www.linkedin.com/in/yankoua-ivan-4442902a9",
      color:
        "bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900",
    },
    {
      name: "Twitter",
      icon: <Twitter size={24} />,
      url: "https://x.com/IvanTsomo67894",
      color:
        "bg-gradient-to-r from-sky-400 to-sky-600 hover:from-sky-500 hover:to-sky-700",
    },
    {
      name: "Email",
      icon: <Mail size={24} />,
      url: "mailto:tsomoivan@gmail.com",
      color:
        "bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700",
    },
    {
      name: "Téléphone",
      icon: <Phone size={24} />,
      url: "tel:+237650695112",
      color:
        "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700",
    },
  ];

  return (
    <section id="contact" className="py-20 relative overflow-hidden">
      {/* Éléments décoratifs d'arrière-plan */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-background to-background/50"></div>
        <div className="absolute top-40 -left-20 w-80 h-80 bg-primary/10 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-40 -right-20 w-80 h-80 bg-accent/10 rounded-full filter blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200%] h-40 bg-muted/20 -rotate-12"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Discutons de votre projet
          </h2>
          <div className="h-1 w-20 bg-gradient-to-r from-primary to-accent mx-auto mb-8"></div>
          <p className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto">
            Vous avez un projet en tête ou une opportunité à me proposer ? Je
            suis toujours ouvert à discuter de nouvelles idées et
            collaborations.
          </p>
        </div>

        <div
          ref={formRef}
          className={`max-w-5xl mx-auto bg-card rounded-2xl shadow-xl overflow-hidden transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"
          }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-5">
            {/* Panneau latéral avec informations de contact */}
            <div className="lg:col-span-2 bg-gradient-to-br from-primary/90 to-accent/90 p-8 lg:p-12 text-white relative">
              {/* Éléments décoratifs */}
              <div className="absolute top-0 right-0 w-40 h-40 bg-white/10 rounded-full -translate-x-10 -translate-y-20"></div>
              <div className="absolute bottom-0 left-0 w-40 h-40 bg-white/10 rounded-full translate-x-10 translate-y-20"></div>

              <div className="relative z-10">
                <h3 className="text-2xl font-bold mb-6 text-center">
                  Restons en contact
                </h3>

                <div className="mb-12">
                  <div className="w-24 h-24 rounded-full overflow-hidden mb-4 border-2 border-white/20 mx-auto">
                    <img
                      src={Images.hero1 || "/placeholder.svg"}
                      alt="profile picture"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h4 className="text-xl font-semibold text-center mb-1">
                    Yankoua Ivan
                  </h4>
                  <p className="text-white/80 text-center mb-6">
                    Développeur Fullstack Node.js
                  </p>
                </div>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="mr-4 bg-white/10 p-3 rounded-full">
                      <Mail className="text-white" size={20} />
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold mb-1 text-white/80">
                        Email
                      </h4>
                      <a
                        href="mailto:john.doe@example.com"
                        className="text-white hover:underline transition-all"
                      >
                        tsomoivan@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mr-4 bg-white/10 p-3 rounded-full">
                      <Phone className="text-white" size={20} />
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold mb-1 text-white/80">
                        Téléphone
                      </h4>
                      <a
                        href="tel:+237650695112"
                        className="text-white hover:underline transition-all"
                      >
                        +237 650 69 51 12
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="mr-4 bg-white/10 p-3 rounded-full">
                      <MapPin className="text-white" size={20} />
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold mb-1 text-white/80">
                        Localisation
                      </h4>
                      <p className="text-white">Cameroun, Douala</p>
                    </div>
                  </div>
                </div>

                <div className="mt-12 pt-8 border-t border-white/20">
                  <p className="text-white/80 mb-4 text-sm">
                    Prêt à transformer vos idées en réalité ? Contactez-moi dès
                    aujourd'hui pour discuter de votre projet.
                  </p>
                  <div className="flex space-x-3">
                    <a
                      href="https://github.com/ivanDev237"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                      aria-label="GitHub"
                    >
                      <Github size={18} />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/yankoua-ivan-4442902a9"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                      aria-label="LinkedIn"
                    >
                      <Linkedin size={18} />
                    </a>
                    <a
                      href="https://x.com/IvanTsomo67894"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="bg-white/10 hover:bg-white/20 w-10 h-10 rounded-full flex items-center justify-center transition-colors"
                      aria-label="Twitter"
                    >
                      <Twitter size={18} />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Formulaire et onglets */}
            <div className="lg:col-span-3 p-8 lg:p-12">
              <div className="flex mb-8 border-b border-muted">
                <button
                  onClick={() => setActiveTab("message")}
                  className={`pb-3 px-4 font-medium text-lg transition-colors relative ${
                    activeTab === "message"
                      ? "text-primary"
                      : "text-foreground/60 hover:text-foreground/80"
                  }`}
                >
                  Envoyer un message
                  {activeTab === "message" && (
                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-primary"></div>
                  )}
                </button>
                <button
                  onClick={() => setActiveTab("social")}
                  className={`pb-3 px-4 font-medium text-lg transition-colors relative ${
                    activeTab === "social"
                      ? "text-primary"
                      : "text-foreground/60 hover:text-foreground/80"
                  }`}
                >
                  Réseaux sociaux
                  {activeTab === "social" && (
                    <div className="absolute bottom-0 left-0 w-full h-0.5 bg-primary"></div>
                  )}
                </button>
              </div>

              {activeTab === "message" ? (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div
                    className={`relative transition-all duration-300 ${
                      focusedInput === "name" ? "transform -translate-y-2" : ""
                    }`}
                  >
                    <label
                      htmlFor="name"
                      className={`absolute left-4 transition-all duration-300 ${
                        focusedInput === "name" || formData.name
                          ? "text-xs text-primary -top-2 bg-card px-2"
                          : "text-foreground/60 top-3"
                      }`}
                    >
                      Nom complet
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("name")}
                      onBlur={() => setFocusedInput(null)}
                      required
                      className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div
                    className={`relative transition-all duration-300 ${
                      focusedInput === "email" ? "transform -translate-y-2" : ""
                    }`}
                  >
                    <label
                      htmlFor="email"
                      className={`absolute left-4 transition-all duration-300 ${
                        focusedInput === "email" || formData.email
                          ? "text-xs text-primary -top-2 bg-card px-2"
                          : "text-foreground/60 top-3"
                      }`}
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("email")}
                      onBlur={() => setFocusedInput(null)}
                      required
                      className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div
                    className={`relative transition-all duration-300 ${
                      focusedInput === "subject"
                        ? "transform -translate-y-2"
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="subject"
                      className={`absolute left-4 transition-all duration-300 ${
                        focusedInput === "subject" || formData.subject
                          ? "text-xs text-primary -top-2 bg-card px-2"
                          : "text-foreground/60 top-3"
                      }`}
                    >
                      Sujet
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("subject")}
                      onBlur={() => setFocusedInput(null)}
                      required
                      className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>

                  <div
                    className={`relative transition-all duration-300 ${
                      focusedInput === "message"
                        ? "transform -translate-y-2"
                        : ""
                    }`}
                  >
                    <label
                      htmlFor="message"
                      className={`absolute left-4 transition-all duration-300 ${
                        focusedInput === "message" || formData.message
                          ? "text-xs text-primary -top-2 bg-card px-2"
                          : "text-foreground/60 top-3"
                      }`}
                    >
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      onFocus={() => setFocusedInput("message")}
                      onBlur={() => setFocusedInput(null)}
                      required
                      rows={5}
                      className="w-full px-4 py-3 rounded-lg border border-muted bg-background/50 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full px-6 py-4 bg-gradient-to-r from-primary to-accent text-white rounded-lg hover:shadow-lg transition-all flex items-center justify-center disabled:opacity-70 group"
                  >
                    {isSubmitting ? (
                      <span className="flex items-center">
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Envoi en cours...
                      </span>
                    ) : (
                      <span className="flex items-center">
                        <Send size={18} className="mr-2" />
                        Envoyer le message
                        <ArrowRight
                          size={18}
                          className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1"
                        />
                      </span>
                    )}
                  </button>

                  {submitSuccess && (
                    <div className="p-4 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 rounded-lg flex items-start">
                      <CheckCircle
                        className="text-green-600 dark:text-green-400 mr-3 mt-0.5"
                        size={18}
                      />
                      <div>
                        <p className="font-medium">
                          Message envoyé avec succès !
                        </p>
                        <p className="text-sm mt-1">
                          Merci pour votre message. Je vous répondrai dès que
                          possible.
                        </p>
                      </div>
                    </div>
                  )}

                  {submitError && (
                    <div className="p-4 bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 rounded-lg">
                      {submitError}
                    </div>
                  )}
                </form>
              ) : (
                <div className="space-y-4 py-4">
                  <p className="text-foreground/80 mb-6">
                    Retrouvez-moi sur les réseaux sociaux ou contactez-moi
                    directement via ces plateformes :
                  </p>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {socialLinks.map((link, index) => (
                      <a
                        key={link.name}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`${link.color} text-white p-4 rounded-lg flex items-center transition-all hover:shadow-lg transform hover:-translate-y-1`}
                        style={{ animationDelay: `${index * 100}ms` }}
                      >
                        <div className="bg-white/20 p-3 rounded-full mr-4">
                          {link.icon}
                        </div>
                        <div>
                          <p className="font-medium">{link.name}</p>
                          <p className="text-sm text-white/80">
                            {link.name === "Email"
                              ? "tsomoivan@gmail.com"
                              : link.name === "Téléphone"
                              ? "+237 650 69 51 12"
                              : `@ivanDev237`}
                          </p>
                        </div>
                        <ArrowRight className="ml-auto" size={18} />
                      </a>
                    ))}
                  </div>

                  <div className="mt-8 pt-6 border-t border-muted">
                    <h4 className="text-lg font-medium mb-4">Disponibilité</h4>
                    <div className="bg-muted/30 p-4 rounded-lg">
                      <p className="text-foreground/80">
                        Je suis actuellement{" "}
                        <span className="text-green-500 font-medium">
                          disponible
                        </span>{" "}
                        pour des projets freelance et des opportunités d'emploi
                        à temps plein.
                      </p>
                      <div className="mt-4 flex items-center">
                        <div className="w-3 h-3 bg-green-500 rounded-full mr-2 animate-pulse"></div>
                        <p className="text-sm text-foreground/60">
                          Réponse généralement en moins de 24 heures
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
